<div style="position: relative">
  <div
    class="switch-circle-container"
    [class.on]="checked"
    (click)="switchClick()"
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="10" r="9" class="switch-circle" />
    </svg>
  </div>
  <div>
    <div fxLayout="row" fxLayoutAlign="start center">
      <div style="cursor: pointer; height: 24px;" (click)="switchClick()">
        <svg width="44" height="24" viewBox="0 0 44 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect class="switch-bar" [ngClass]="{ 'is-active': checked, 'is-disabled': disabled }" width="44" height="24" rx="12" />
        </svg>
      </div>
    </div>
  </div>
</div>
